export default {
  init() {
    const hoverCardBlock = $('.hover-card-block');
    if (hoverCardBlock.length) {
      hoverCardBlock.each(function() {
        const thisHoverCardBlock = $(this);
        const buttons = thisHoverCardBlock.find('.image-link-item-button');
        const images = thisHoverCardBlock.find('.image-link-item-image-wrapper');

        if (buttons.length) {
          buttons.each(function() {
            const thisButton = $(this);
            const index = thisButton.data('index');

            thisButton.on('mouseover', function() {
              buttons.removeClass('active');
              images.removeClass('active');

              thisButton.addClass('active');
              thisHoverCardBlock.find(`.image-link-item-image-wrapper[data-index="${index}"]`).addClass('active');
            });
          });
        }
      });
    }
  },
  finalize() {},
};



// WEBPACK FOOTER //
// ./scripts/routes/acf-blocks/hoverCard.js